import { useTranslate } from "src/i18n/useTranslate"
import { MBadge } from "src/ui/MBadge/MBadge"

export function BetaFeaturePill() {
  const { t, langKeys } = useTranslate()

  return <MBadge color="info">{t(langKeys.beta)}</MBadge>
}
